export const colors = {
  red:     '#E8192C',
  redDim:  'rgba(232,25,44,0.1)',
  redGlow: 'rgba(232,25,44,0.15)',
  bg:      '#0A0A0C',
  surface: '#111114',
  card:    '#18181D',
  hover:   '#1E1E24',
  border:  '#2A2A32',
  text:    '#F0F0F2',
  muted:   '#6B6B7A',
};

export const statusChipClass = {
  inward_pending:       'chip-amber',
  received:             'chip-amber',
  partially_quarantined:'chip-amber',
  cleared:              'chip-green',
  stored:               'chip-green',
  completed:            'chip-green',
  delivered:            'chip-green',
  quarantine:           'chip-red',
  quarantined:          'chip-red',
  rejected:             'chip-gray',
  dispatched:           'chip-blue',
  in_transit:           'chip-blue',
  pending:              'chip-amber',
  pending_qc:           'chip-purple',
  qc_passed:            'chip-green',
  qc_failed:            'chip-red',
  direct_delivery:      'chip-purple',
  inspection_failed:    'chip-amber',
  released:             'chip-green',
  security_out:         'chip-blue',
  resource_verified:    'chip-purple',
  on_hold:              'chip-red',
  held:                 'chip-amber',
  partial:              'chip-amber',
};

export const statusLabel = {
  inward_pending:        'Inward Pending',
  received:              'Received',
  partially_quarantined: 'Partial QC',
  cleared:               'Cleared',
  stored:                'Stored',
  completed:             'Completed',
  delivered:             'Delivered',
  quarantine:            'Quarantine',
  quarantined:           'Quarantined',
  rejected:              'Rejected',
  dispatched:            'Dispatched',
  in_transit:            'In Transit',
  pending:               'Pending',
  pending_qc:            'Pending QC',
  qc_passed:             'QC Passed',
  qc_failed:             'QC Failed',
  inspection_failed:     'Inspection failed',
  released:              'Released / Exited',
  security_out:          'Security Outward',
  resource_verified:     'Resource Verified',
  on_hold:               'On Hold',
  held:                  'On Hold',
  partial:               'Partial',
};
